import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { tourAssignmentService } from "../../services/tourAssignmentService";
import { toast } from "react-toastify";
import Layout from "../layout/layout";
import Sidebar from "../profile-sidebar/profileSidebar";

const ViewTourGuide = () => {
  const { tourAssignmentId } = useParams(); // Lấy tourAssignmentId từ URL
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAssignments = async () => {
      setLoading(true);
      try {
        const data = await tourAssignmentService.getTourGuideAssignmentsByTour(
          tourAssignmentId
        );
        console.log(data);
        setAssignments(data.data || []);
      } catch (error) {
        console.error("Error fetching assignments:", error);
        toast.error("Không thể tải danh sách hướng dẫn viên.");
        setAssignments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAssignments();
  }, [tourAssignmentId]);

  const handleReplaceTourGuideMain = (tourAssignmentId) => {
    const backupAssignment = assignments.find(
      (a) => a.role.toLowerCase() === "backup"
    );
    const backupId = backupAssignment ? backupAssignment.tourGuideId : null;

    if (!backupId) {
      toast.error(
        "Không tìm thấy hướng dẫn viên dự phòng (Backup) để thay thế."
      );
      return;
    }

    navigate(
      `/replace-tour-guide-main?tourAssignmentId=${tourAssignmentId}&backupId=${backupId}`
    );
  };

  const handleReplaceTourGuideBackup = async (tourAssignmentId) => {
    const mainAssignment = assignments.find(
      (a) => a.role.toLowerCase() === "main"
    );
    const mainId = mainAssignment ? mainAssignment.tourGuideId : null;

    if (!mainId) {
      toast.error("Không tìm thấy hướng dẫn viên dự phòng (Main) để thay thế.");
      return;
    }

    navigate(
      `/replace-tour-guide-backup?tourAssignmentId=${tourAssignmentId}&mainId=${mainId}`
    );
  };

  const renderStatus = (status) => {
    let dotStyle = {};
    switch (status.toLowerCase()) {
      case "pending":
        dotStyle = { backgroundColor: "yellow" };
        break;
      case "cancel":
        dotStyle = { backgroundColor: "red" };
        break;
      case "confirmed":
        dotStyle = { backgroundColor: "green" };
        break;
      default:
        dotStyle = { backgroundColor: "gray" };
    }

    return (
      <span style={{ display: "flex", alignItems: "center" }}>
        <span
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            display: "inline-block",
            marginRight: "5px",
            ...dotStyle,
          }}
        ></span>
        {status}
      </span>
    );
  };

  return (
    <Layout>
      <div className="content">
        <div className="container">
          <div className="row">
            <Sidebar page="tour-assign" />
            <div className="col-xl-9 col-lg-8">
              <div className="card shadow-none mb-0">
                <div className="card-header">
                  <h6>
                    Danh sách hướng dẫn viên cho #
                    {assignments && assignments.length > 0
                      ? assignments[0].tourName
                      : ""}
                  </h6>
                </div>
                <div className="card-body">
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                    </div>
                  ) : assignments.length === 0 ? (
                    <p>Không có hướng dẫn viên nào được phân công.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Ảnh</th>
                            <th>Tên hướng dẫn viên</th>
                            <th>Email</th>
                            <th>Số điện thoại</th>
                            <th>Vai trò</th>
                            <th>Trạng thái</th>
                            <th>Hành động</th>
                          </tr>
                        </thead>
                        <tbody>
                          {assignments.map((assignment) => (
                            <tr key={assignment.id}>
                              <td>
                                <img
                                  src={assignment.imageUrl || ""}
                                  alt={assignment.fullName}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                  }}
                                />
                              </td>
                              <td>{assignment.guideFullName}</td>
                              <td>{assignment.email}</td>
                              <td>{assignment.phoneNumber}</td>
                              <td>{assignment.role}</td>
                              <td>{renderStatus(assignment.status)}</td>
                              <td>
                                {assignment.status === "Pending" ? (
                                  <>
                                    {assignment.role === "Main" ? (
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                          handleReplaceTourGuideMain(
                                            assignment.tourAssignmentId
                                          )
                                        }
                                        disabled={loading}
                                      >
                                        Thay đổi
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                          handleReplaceTourGuideBackup(
                                            assignment.tourAssignmentId
                                          )
                                        }
                                        disabled={loading}
                                      >
                                        Thay đổi
                                      </button>
                                    )}
                                  </>
                                ) : assignment.status === "Cancel" ? (
                                  <>
                                    {assignment.role === "Main" ? (
                                      assignment.confirmedTourGuideCount ==
                                      1 ? (
                                        <button
                                          className="btn btn-primary btn-sm"
                                          onClick={() =>
                                            handleReplaceTourGuideBackup(
                                              assignment.tourAssignmentId
                                            )
                                          }
                                          disabled={loading}
                                        >
                                          Chuyển TourGuide phụ thành TourGuide
                                          chính
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-primary btn-sm"
                                          onClick={() =>
                                            handleReplaceTourGuideMain(
                                              assignment.tourAssignmentId
                                            )
                                          }
                                          disabled={loading}
                                        >
                                          Thay người khác
                                        </button>
                                      )
                                    ) : (
                                      assignment.role === "Backup" && (
                                        <button
                                          className="btn btn-primary btn-sm"
                                          onClick={() =>
                                            handleReplaceTourGuideBackup(
                                              assignment.tourAssignmentId
                                            )
                                          }
                                          disabled={loading}
                                        >
                                          Thay người khác
                                        </button>
                                      )
                                    )}
                                  </>
                                ) : (
                                  "Đã được xác nhận"
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ViewTourGuide;
